<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        elevationLevel?: 'canvas' | 'stacked' | 'above' | 'sticky';
        inverted?: boolean;
        size?: '100' | '50';
        backgroundColor?: string;
        /*                                                                                        */
        disableOverlayEffect?: boolean;
        /*                                                                                          */
        element?: HTMLElement | null;
        /*                                                                                               */
        primaryAction?: Snippet;
        /*                                        */
        children?: Snippet;
        /*                                                                                                 */
        [key: `data-${string}`]: string | undefined;
        /**
 *
 *
 */
        fullHeight?: boolean;
    }

    let {
        elevationLevel = 'canvas',
        inverted = false,
        size = '100',
        backgroundColor,
        disableOverlayEffect = false,
        element = $bindable(null),
        primaryAction,
        children,
        fullHeight = false,
        ...rest
    }: Props = $props();
</script>

<div
    {...rest}
    class="reptile-card"
    class:reptile-card--size-50={size === '50'}
    class:reptile-card--inverted={inverted}
    class:reptile-card--full-height={fullHeight}
    data-elevation-level={elevationLevel}
    style:--reptile-card-background-color={backgroundColor}
    bind:this={element}
>
    <div class="reptile-card__surface" class:reptile-card__surface--no-overlay={disableOverlayEffect}>
        {@render primaryAction?.()}
        {@render children?.()}
    </div>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    .reptile-card {
        display: block;
        position: relative;
        container-type: inline-size;
        border-radius: tokens.$oc-semantic-border-radius-200;

        &--size-50 {
            border-radius: tokens.$oc-semantic-border-radius-100;
        }

        /*                                                                                              */
        &[data-elevation-level='canvas'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-background-canvas});
            filter: tokens.$oc-semantic-shadow-canvas;
        }

        &[data-elevation-level='stacked'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-stacked-background});
            filter: tokens.$oc-semantic-shadow-stacked;
        }

        &[data-elevation-level='above'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-above-background});
            filter: tokens.$oc-semantic-shadow-above;
            transform: translateZ(0); /*                                                     */
        }

        &[data-elevation-level='sticky'] {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-sticky-background});
            filter: tokens.$oc-semantic-shadow-sticky;
            transform: translateZ(0); /*                                                     */
        }

        /*                                                                                               */
        /*                                                 */
        &--inverted {
            background-color: var(--reptile-card-background-color, #{tokens.$oc-semantic-color-background-strong-mint});
            color: tokens.$oc-semantic-color-text-inverted;
        }

        &--full-height {
            height: 100%;
        }
    }

    .reptile-card__surface {
        display: block;
        position: relative;
        overflow: hidden; /*                                                                          */
        width: 100%;
        height: 100%;
        border-radius: inherit;

        /*                                                                                 */
        /*                                                                                           */
        /*                                                                                    */
        /*                                            */
        :global(> [data-primary-action]) {
            all: unset;
            display: block;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            pointer-events: auto;
            cursor: pointer;

            position: absolute;
            inset: 0;
        }

        /*                                                                     */
        :global(> [data-primary-action] > a) {
            position: absolute;
            inset: 0;
        }

        /*                                                                                         */
        /*                                                                               */
        &:has(:global(> [data-primary-action])) {
            pointer-events: none;
        }

        @media (hover: hover) and (pointer: fine) {
            &:not(.reptile-card__surface--no-overlay):has(:global(> [data-primary-action])):hover::after {
                content: '';
                position: absolute;
                inset: 0;
                pointer-events: none;
                border-radius: inherit;
                background-color: tokens.$oc-semantic-color-overlay-hover;
            }
        }

        &:not(.reptile-card__surface--no-overlay):has(:global(> [data-primary-action]:active))::after {
            content: '';
            position: absolute;
            inset: 0;
            pointer-events: none;
            border-radius: inherit;
            background-color: tokens.$oc-semantic-color-overlay-active;
        }

        :global([data-secondary-action]) {
            pointer-events: auto;
            position: relative;
        }
    }
</style>
